module.exports = __webpack_public_path__ + "static/media/mem8YaGs126MiZpBA-UFWZ0bbck.a47b9667.woff2";